module.exports = __webpack_public_path__ + "img/promotion3.2946a4b0.png";